// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const submitTimesheetProposalPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.coerce.string().describe("Proposal ID (uuid)"),
});

export const submitTimesheetProposalHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Proposal submitted
 */
export const submitTimesheetProposal200Schema = z.object({
  proposal: z.object({
    id: z.coerce.string(),
    date: z.string().date(),
    user_id: z.optional(z.number().int()),
    status: z.enum(["pending", "accepted", "rejected", "edited"]),
    log: z.optional(z.array(z.object({}))),
    metadata: z.optional(z.object({})),
    created_at: z.optional(z.coerce.string()),
    updated_at: z.coerce.string().nullish(),
    entries: z.optional(z.array(z.object({
      id: z.number().int(),
      timesheet_proposal_id: z.coerce.string(),
      date: z.string().date(),
      timely_project_id: z.number().int().nullish(),
      timely_label_ids: z.optional(z.array(z.number().int())),
      started_at: z.coerce.string().nullish(),
      ended_at: z.coerce.string().nullish(),
      hour_id: z.number().int().nullish(),
      note: z.coerce.string().nullish(),
      duration_minutes: z.number().int().nullish(),
      resource_id: z.coerce.string().nullish(),
      metadata: z.optional(z.object({})),
      created_at: z.optional(z.coerce.string()),
      updated_at: z.coerce.string().nullish(),
    }))),
    items: z.optional(z.array(z.object({
      id: z.number().int(),
      timesheet_proposal_id: z.coerce.string(),
      timesheet_proposal_entry_id: z.number().int().nullish(),
      started_at: z.coerce.string().nullish(),
      ended_at: z.coerce.string().nullish(),
      note: z.coerce.string().nullish(),
      metadata: z.optional(z.object({})),
      created_at: z.optional(z.coerce.string()),
      updated_at: z.coerce.string().nullish(),
    }))),
  }),
  created_hour_ids: z.array(z.number().int()),
});

/**
 * @description Proposal not found
 */
export const submitTimesheetProposal404Schema = z.object({
  message: z.coerce.string(),
});

/**
 * @description An entry failed validation (e.g. archived label) — nothing was submitted
 */
export const submitTimesheetProposal422Schema = z.object({
  message: z.coerce.string(),
  row_errors: z.optional(z.array(z.object({
    entry_id: z.number().int().describe("timesheet_proposal_entry id of the invalid row"),
    messages: z.array(z.coerce.string()).describe("HourForm validation messages for the row"),
  })).describe("Per-entry validation failures that caused the submit to be refused (atomic; one entry per invalid row).")),
});

export const submitTimesheetProposalMutationRequestSchema = z.object({
  entries: z.optional(z.array(z.object({
    id: z.number().int().describe("timesheet_proposal_entry id this link-set belongs to"),
    external_links: z.optional(z.array(z.object({
      provider_type: z.optional(z.coerce.string()),
      provider_id: z.coerce.string().nullish(),
      external_id: z.coerce.string().nullish(),
      uri: z.optional(z.coerce.string()),
      data: z.optional(z.object({})),
    }))),
  })).describe("Per-entry external_links the FE resolved (Option a2). Each item is keyed to a persisted proposal entry by its id.")),
});

export const submitTimesheetProposalMutationResponseSchema = z.lazy(() => submitTimesheetProposal200Schema);
